class requiredPackages {

  constructor() {
    this.storeId = null;
  }

  init() {
    this.customerId = typeof window.customerId != "undefined" ? parseInt(window.customerId) : null;
    this.storeId = typeof window.storeId != "undefined" ? parseInt(window.storeId) : null;

    this.bindEvents();
  }

  bindEvents() {
    let _this = this;

    // w
    if (document.querySelector('.remove-package-parent')) {
      document.querySelector('.remove-package-parent').addEventListener('click', (e) => {
        localStorage.removeItem('required_package_addon');
        localStorage.removeItem('required_package_initialized');
        localStorage.removeItem('required_package_handle');
        localStorage.removeItem('required_package_unique_id');
        localStorage.removeItem('required_package_parent_id');
        localStorage.removeItem('required_package_products');
        localStorage.removeItem('required_package_recommended');
      });
    }

    /**
     * When clicking "add kit to cart" on a kit parent product
     */
    if (document.querySelector('.add-kit-to-cart')) {
      document.querySelector('.add-kit-to-cart').addEventListener('click', (e) => {
        e.preventDefault();

        let el = e.target;

        if (el.dataset.addToCart === 'true') {
          let valid = _this.validateProductForm();
          if (!valid) {
            e.stopPropagation();
            return false;
          } else {
            _this.addParentProductToCart(el).then(
              (response) => {
                window.location.href = el.getAttribute('href');
              },
              (error) => {
                console.log('error')
                console.log(error)
              }
            ).catch(err => {
              console.log('err')
              console.log(err)
            });
          }
        } else {
          window.location.href = el.getAttribute('href');
        }
      });
    }

    /**
     * When clicking "continue" on a package child item product
     */
    if(document.querySelector('.add-required-package-product-to-cart')) {
      document.querySelectorAll('.add-required-package-product-to-cart').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          let valid = _this.validateProductForm();
          if (!valid) {
            e.stopPropagation();
            return false;
          } else {
            //_this.addRequiredPackageProductToCart();
            fetch('/cart.js').then(res => res.json()).then(cart => {
              _this.addChildProductToCart(e.target, cart).then(
                (response) => {
                  window.location.href = el.getAttribute('href');
                },
                (error) => {
                  console.log('error')
                  console.log(error)
                }
              ).catch(err => {
                console.log('err')
                console.log(err)
              });
            });
          }
        });
      })
    }

    if (document.querySelector('.required-package-addon-add')) {
      document.querySelector('.required-package-addon-add').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        let id = e.target.closest('form').querySelector('[name="id"]').value;
        let qty = e.target.closest('.product-form').querySelector('input[name="quantity"]').value;

        let kitId = localStorage.getItem('required_package_initialized');
        let properties = {};
        properties['_required_package_addon'] = true;
        //properties['_required_package_item'] = true;
        properties['_kit_id'] = kitId;

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            "id": id,
            "quantity": qty,
            "properties": properties
          },
          dataType: 'json',
          success: function () {
            window.location.href = e.target.getAttribute('href');
          }
        });
      });
    }

    if (document.querySelector('.required-packages-add-recommended-to-cart')) {
      document.querySelector('.required-packages-add-recommended-to-cart').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        _this.submitRequiredPackageRecommended($(this));
        return false;
      });
    }

    document.addEventListener('DOMContentLoaded', (e) => {
      if (localStorage.getItem('required_package_initialized') == null) {
        document.querySelector('body').classList.remove('required-package-initialized');
      } else if (document.querySelector('.required-packages-thank-you') != null) {
        _this.initRequiredPackageThankYou();
      } else {
        let isParent = false;
        if (document.querySelector('body').classList.contains('is-kit-product')) {
          isParent = true;
        }
        _this.initRequiredPackage(false, isParent);
      }
    });

    document.querySelectorAll('.quantity-selector__button.is-disabled').forEach(el => {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      });
    });

  }

  addParentProductToCart(btn) {
    if(!btn) return;

    return new Promise(async (resolve, reject) => {
      let variantId = document.querySelector('input[name="id"]');
      if(!variantId) return;
      variantId = variantId.value;

      if (!variantId) {
        reject({
          status: null,
          message: 'Wrong/missing product ID',
          variantId: null,
        });
      }

      let properties = {};
      let uniqueId = Math.random().toString(36).slice(2, 9);
      properties['_required_package_unique_id'] = uniqueId.toString();
      properties['_required_package_parent'] = true;

      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1,
          'properties': properties
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => response.json())
        .then((response) => {

        if (typeof response.items != 'undefined' && response.items.length > 0) {

          localStorage.setItem('required_package_unique_id', uniqueId);
          if (typeof btn.dataset.kitid != "undefined") {
            localStorage.setItem('required_package_initialized', btn.dataset.kitid);
          }
          if (typeof btn.dataset.addonHandle != "undefined") {
            localStorage.setItem('required_package_addon', btn.dataset.addonHandle);
          }
          if (typeof btn.dataset.handle != "undefined") {
            localStorage.setItem('required_package_handle', btn.dataset.handle);
          }
          if (typeof btn.dataset.recommendedProducts != "undefined") {
            localStorage.setItem('required_package_recommended', btn.dataset.recommendedProducts);
          }
          if (typeof btn.dataset.kitProducts != "undefined") {
            localStorage.setItem('required_package_products', btn.dataset.kitProducts);
          }

          response.items.forEach((item) => {
            if(item.id == variantId) {
              localStorage.setItem('required_package_parent_id', item.id);
            }
          })

          resolve({
            status: 200,
            message: 'Success',
            variantId: variantId
          });

          return;
        }

        reject({
          response: response,
          message: response.message,
          variantId: variantId,
        });
      }).catch((e) => {
        reject({
          response: e,
          message: e.message,
          variantId: variantId,
        });
      })
    });

  }

  addChildProductToCart(btn, cart) {
    let _this = this;
    if(!btn || !cart) return;
    let parentId = localStorage.getItem('required_package_parent_id');
    let uniqueId = localStorage.getItem('required_package_unique_id');
    if(!parentId || !uniqueId) return;

    return new Promise(async (resolve, reject) => {
      let variantId = document.querySelector('input[name="id"]');
      if(!variantId) return;
      variantId = variantId.value;

      if (!variantId) {
        reject({
          status: null,
          message: 'Wrong/missing product ID',
          variantId: null,
        });
      }

      let properties = {};
      cart.items.forEach((item) => {
        if(item.id == parentId) {
          properties = item.properties;
        }
      });

      let currentStep = btn.dataset.currentStep;
      //properties[`${currentStep}_properties`] = 'test'

      let attributes = cart.attributes;
      let newProperties = {};
      let form = document.querySelector('.product-purchase-form');
      if(!form) return;
      var formData = new FormData(form);

      var currentForm = {};
      formData.forEach(function(value, key){
        currentForm[key] = value;
      });

      for (let [key, value] of Object.entries(currentForm)) {
        if(key.includes('attributes')) {
          key = key.replace('attributes[','');
          key = key.replace(']','');
          attributes[key] = value;
        }
        else if(key.includes('properties')) {
          key = key.replace('properties[','');
          key = key.replace(']','');
          newProperties[key] = value;
        }
      }

      newProperties.uniqueId = uniqueId;

      if(!properties.hasOwnProperty('_required_package_child_items')) {
        properties['_required_package_child_items'] = {};
      }
      else {
        properties['_required_package_child_items'] = JSON.parse(properties['_required_package_child_items']);
      }

      properties['_required_package_child_items'][variantId] = {
        quantity: currentForm.quantity,
        properties: newProperties
      };

      properties['_required_package_child_items'] = JSON.stringify(properties['_required_package_child_items']);

      let updates = {
        'id': parentId,
        'quantity': currentForm.quantity,
        'properties': properties
      };

      await _this.updateCartAttributes(attributes);

      fetch('/cart/change.js', {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      }).then(response => {

        if (typeof response.status != 'undefined' && response.status == 200) {
          resolve({
            status: 200,
            message: 'Success',
            variantId: variantId
          });

          return;
        }

        reject({
          response: response,
          message: response.message,
          variantId: variantId,
        });
      });
    });
  }

  updateCartAttributes(attributes) {

    let updates = {
      attributes: attributes
    }

    return new Promise(async (resolve, reject) => {
      fetch('/cart/update.js', {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      }).then(response => {

        if (typeof response.status != 'undefined' && response.status == 200) {
          resolve({
            status: 200,
            message: 'Success',
          });

          return;
        }

        reject({
          response: response,
          message: response.message,
        });
      });

    });
  }

  validateProductForm = function () {
    let btn = $(this);
    let form = btn.closest('form');

    let valid = true;
    let personalized = false;

    if (form.find('.field-container:not(.gift-card-field) .custom-field').length > 0) {
      form.find('.field-container:not(.gift-card-field) .custom-field').each(function () {
        let field = $(this);

        if (field.val().length > 1) personalized = true;

        if (field.hasClass('required') && field.val().length < 1) {
          valid = false;
          field.closest('.field-container').addClass('error');
        } else if (field.hasClass('required') && field.hasClass('select') && field.val() == '0') {
          valid = false;
          field.closest('.field-container').addClass('error');
        } else {
          field.removeClass('error');
          field.closest('.field-container').removeClass('error');
        }
      });

      if (personalized) {
        if (form.find('input[name="properties[_personalized]"]').length < 1) {
          form.append('<input type="hidden" name="properties[_personalized]" value="true"/>');
        } else form.find('input[name="properties[_personalized]"]').val('true');
      }
    }

    return valid;
  };

  submitRequiredPackageRecommended(button) {
    let form = button.closest('form')[0];
    let formData = new FormData(form);

    let variants = form.closest('.product-card').dataset.variants;
    if (variants != null) variants = JSON.parse(variants);

    // get options and qty
    let values = [];
    let qty = 1
    for (let pair of formData.entries()) {

      if (pair[0] === 'Size' ||
        pair[0] === 'Color') {
        values.push(pair[1]);
      }
      if (pair[0] === 'quantity') qty = pair[1];
    }

    // get variant ID
    let variantId = null;
    if (variants != null) {
      variants.forEach(function (variant) {
        let useThisVariant = true;
        values.forEach(function (value) {
          if (!variant.options.includes(value)) {
            useThisVariant = false;
          }
        });

        if (useThisVariant) {
          variantId = variant.id;
        }
      });
    }

    if (variantId != null) {
      form.querySelector('input[name="id"]').value = variantId;

      // submit and show mini cart
      const productForm = new FormData(form);
      productForm.append("sections", ["mini-cart"]);
      productForm.delete("option1");
      productForm.delete("option2");
      productForm.delete("option3");
      const response = fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
        body: productForm,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(response => response.json())
        .then(data => {

          if (data.status != 422) {
            form.dispatchEvent(new CustomEvent("cart-notification:show", {
              bubbles: true,
              cancelable: true,
              detail: {
                status: "success"
              }
            }));
          } else {
            form.dispatchEvent(new CustomEvent("cart-notification:show", {
              bubbles: true,
              cancelable: true,
              detail: {
                status: data.ok ? "success" : "error",
                error: data.description || ""
              }
            }));
          }

        }).catch(error => {
          console.log(error)
        });
    }
  }

  initRequiredPackageThankYou() {
    let _this = this;
    let handle = localStorage.getItem('required_package_handle');
    fetch("/products/" + handle + ".json")
      .then(response => response.json())
      .then(data => {
        _this.parseRequiredPackageThankYou(data.product)
      }).catch(error => {
      console.log(error)
    });
  }

  parseRequiredPackageThankYou(product) {
    let _this = this;
    let recommended = localStorage.getItem('required_package_recommended');
    if (recommended != null) recommended = JSON.parse(recommended);
    let img = document.querySelector('.required-packages-thank-you .product-image img');
    let recommendedContainer = document.querySelector('.required-packages-thank-you .required-packages-recommended');
    img.setAttribute('src', product.image.src);
    img.setAttribute('alt', product.image.alt);

    let tpl = document.querySelector('.required-packages-thank-you .product-card-tpl');

    if (recommended != null) {
      recommended.forEach(function (prod) {
        let clone = tpl.cloneNode(true);
        clone.classList.remove('product-card-tpl');
        clone.classList.add('product-card');
        clone.dataset.handle = prod.handle;
        clone.dataset.variants = JSON.stringify(prod.variants);
        clone.querySelector('img').setAttribute('src', prod.featured_image);
        clone.querySelector('.title').innerHTML = prod.title;

        if (prod.variants != null && prod.variants.length > 1) {
          let optionsData = _this.parseRequiredPackageThankYouOptions(prod);

          // append options to dropdowns
          for (const optionName in optionsData) {
            if (optionsData.hasOwnProperty(optionName)) {
              let values = optionsData[optionName];
              let targetCont = clone.querySelector('.field.' + optionName);

              if(targetCont) {
                let target = targetCont.querySelector('select');

                values.forEach(function (value) {
                  let opt = document.createElement('option');
                  opt.setAttribute('value', value);
                  opt.innerHTML = value;
                  target.appendChild(opt);
                });

                targetCont.classList.remove('hidden');
              }
            }
          }
        }

        recommendedContainer.appendChild(clone);

      });
    }

    localStorage.removeItem('required_package_initialized');
    localStorage.removeItem('required_package_handle');
    localStorage.removeItem('required_package_unique_id');
    localStorage.removeItem('required_package_products');
    localStorage.removeItem('required_package_parent_id');
    localStorage.removeItem('required_package_addon');
  }

  parseRequiredPackageThankYouOptions(prod) {
    let data = {};

    let i = 1;
    prod.options.forEach(function (option) {
      if (typeof data[option] == "undefined") {
        data[option] = [];
      }

      prod.variants.forEach(function (variant) {
        if (!data[option].includes(variant['option' + i])) {
          data[option].push(variant['option' + i]);
        }
      });

      i++;
    });

    return data;

  }

  initRequiredPackage(redirect = false, isParent = false) {
    let _this = this;
    let cont = document.querySelector('.required-packages-container');
    if (cont == null) return;
    let productHandle = cont.dataset.productHandle;

    let products = JSON.parse(localStorage.getItem('required_package_products'));

    let currentIndex = null;
    for (let i = 0; i < products.length; i++) {
      if (products[i].handle == productHandle) {
        currentIndex = i;
      }
    }

    let isAddon = false;
    if (localStorage.getItem('required_package_addon') != null) {
      if (window.location.href.indexOf("products/" + localStorage.getItem('required_package_addon')) > -1) {
        document.querySelector('body').classList.add('is-kit-addon');
        currentIndex = products.length - 1;
        isAddon = true;
      }
    }

    fetch("/cart.js")
      .then(response => response.json())
      .then(data => {
        _this.parseRequiredPackage(data, products, currentIndex, redirect, isAddon, isParent);
      }).catch(error => {
      console.log(error)
    });
  }

  parseRequiredPackage(data, products, currentIndex, redirect, isAddon, isParent) {
    let cont = document.querySelector('.required-packages-container');
    let productHandle = cont.dataset.productHandle;
    let items = data.items;
    let prevItem = null;
    let nextItem = null;
    let currentItem = null;
    let currentCartItem = null;
    let total = products.length;

    let i = 0;
    let current = i;
    let step = currentIndex + 1;
    let _uniqueId = localStorage.getItem('required_package_unique_id');

    // save last visited product so we know where to redirect if a customer navigates away from the bundle
    localStorage.setItem('required_package_last_step', step);

    // Find out which step we're on
    products.forEach(function (_product) {
      let inCart = false;
      items.forEach(function (item) {
        let uniqueId = item.properties['_required_package_unique_id'];
        if (uniqueId == _uniqueId && item.handle == _product.handle) {
          inCart = true;
          current++;
          if (item.handle == productHandle) {
            currentCartItem = item;
          }
        }
      });
      if (!nextItem && _product.handle != productHandle) {
        nextItem = _product;
      } else if (_product.handle == productHandle) {
        currentItem = _product;
      }
      i++;
    });

    if (currentIndex > 0) {
      prevItem = products[currentIndex - 1];
    }
    if (typeof products[step] != "undefined" && step != products.length) {
      nextItem = products[step];
    }

    if (currentIndex != null && !isAddon) {
      currentItem = products[currentIndex];
    } else {
      // redirect to the last visited bundle product if available, otherwise redirect to first bundle product
      let lastStep = localStorage.getItem('required_package_last_step');
      if(!lastStep) lastStep = 0;
      prevItem = products[lastStep];
      nextItem = null;
    }

    if(step == products.length) {
      nextItem = null
    }

    // Check if we're on the last step or not
    if (total == current) {
      let packagesInCart = 0;
      let uniqueIds = [];
      items.forEach(item => {
        if (item.properties.hasOwnProperty('_required_package_unique_id')) {
          let uniqueId = item.properties['_required_package_unique_id'];
          if (!uniqueIds.includes(uniqueId)) {
            uniqueIds.push(uniqueId);
          }
        }
      });

      packagesInCart = uniqueIds.length;

      // update cart attributes with "__required_package_in_cart"
      var formData = new FormData();
      formData.append("attributes[_required_packages_in_cart]", packagesInCart.toString());
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          localStorage.removeItem('required_package_initialized');
          localStorage.removeItem('required_package_handle');
          localStorage.removeItem('required_package_unique_id');
        });

    } else if (total > current) {
      if (window.location.href.indexOf("cart") > -1) {
        this.clearKitItems(uniqueId, data);
      }

      let isInKitProducts = false;
      // check if current product is a child product
      products.some((item) => {
        if(item.handle == productHandle) isInKitProducts = true;
      });

      if(!isParent && !isInKitProducts) redirect = true;

    }

    let btn = cont.querySelector('.add-required-package-product-to-cart');

    btn.dataset.currentStep = step;

    // Set the correct URL, depending which step we're on
    if (nextItem) {
      btn.setAttribute('href', '/products/' + nextItem.handle);
      btn.dataset.lastItem = 'false';
    } else {
      if (localStorage.getItem('required_package_addon') != null) {
        btn.setAttribute('href', '/products/' + localStorage.getItem('required_package_addon'));
      } else {
        btn.setAttribute('href', '/cart');
      }
      btn.dataset.lastItem = 'true';
    }

    // If we're not on the first item, set up the back button
    if (prevItem && currentIndex > 0 || prevItem && currentIndex == null) {
      cont.querySelector('.required-package-back').setAttribute('href', '/products/' + prevItem.handle);
      cont.querySelector('.required-package-back').classList.remove('hidden');
    }

    // Set up required quantity
    if (currentItem) {
      cont.dataset['requiredQuantity'] = currentItem.quantity;
      document.querySelector('input[name="quantity"]').value = parseInt(currentItem.quantity);
      document.querySelector('input[name="quantity"]').setAttribute('min', currentItem.quantity);
      document.querySelector('input[name="quantity"]').setAttribute('value', currentItem.quantity);
    }

    // Fill in custom fields if we already have this item in cart and it was already personalized
    if (currentCartItem) {
      for (var prop in currentCartItem.properties) {
        if (document.querySelector('input[name="properties[' + prop + ']"]') != null) {
          document.querySelector('input[name="properties[' + prop + ']"]').value = currentCartItem.properties[prop];
        }
      }
    }

    if (current > total) current = total;

    // Set up progress container
    let progressContainer = cont.querySelector('.progress-container');
    progressContainer.querySelector('.current').innerHTML = step;
    progressContainer.querySelector('.total').innerHTML = total;
    progressContainer.querySelector('.percentage .bg').style.width = (parseInt(step) / parseInt(total)) * 100 + '%';

    // Redirect if necessary
    if (redirect) {
      if (prevItem) window.location.href = '/products/' + prevItem.handle
      else if (nextItem) window.location.href = '/products/' + nextItem.handle
    }
  }

  clearKitItems(uniqueId, data = null) {
    let _this = this;

    if (data == null) {
      fetch("/cart.js")
        .then(response => response.json())
        .then(data => {
          _this.clearKitItems(uniqueId, data);
        }).catch(error => {
        console.log(error)
      });
      return;
    }

    let cartItems = data.items;
    let packagesInCart = parseInt(data.attributes['_required_packages_in_cart'])

    let updates = {};

    cartItems.forEach(function (cartItem) {
      if (cartItem.properties.hasOwnProperty('_required_package_unique_id') && uniqueId == cartItem.properties['_required_package_unique_id']) {
        updates[cartItem.variant_id] = 0;
      }
    });

    let newPackagesInCart = packagesInCart - 1;

    let _data = {
      updates: updates,
      attributes: {
        '_required_packages_in_cart': newPackagesInCart
      }
    }

    fetch('/cart/update.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(_data)
    }).then(response => {
      localStorage.removeItem('required_package_addon');
      localStorage.removeItem('required_package_initialized');
      localStorage.removeItem('required_package_handle');
      localStorage.removeItem('required_package_unique_id');

      if (document.querySelector('body').classList.contains('template-cart')) {
        window.location.reload();
      } else {
        setTimeout(function () {
          const cartContent = response;
          cartContent["sections"] = response["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
        }, 1000)
      }

    });
  }

}

let bundles = new requiredPackages();
bundles.init();








